import ApiService from '../services/api';
import ActionTemplate from './services/actionTemplate';

const PXPAY = 'PXPAY';

/** Actions for Payment Token */
export default class CSProcessPaymentAction {

    constructor() {
        this.api = new ApiService();
        this.actionTemplate = new ActionTemplate();
    }

    /**********************************************************/
    /**********************PROCESS PAYMENT*********************/
    /**********************************************************/

    processPayment(region, result, userid){
        const requestBody = {
            region: region,
            result: result,
            userid: userid,
        };
        return (dispatch) => {
            dispatch(this.actionTemplate.request(PXPAY));
            const url = '/payment_link_pxpay/dps';
            return this.api.post(url, requestBody)
                .then((response) => {
                    if (response.data){
                        dispatch(this.actionTemplate.success(PXPAY, response.data));
                    } else {
                        dispatch(this.actionTemplate.failure(PXPAY, response.toString()));
                    }
                })
                .catch((err) => {
                    /* istanbul ignore next */ 
                    dispatch(this.actionTemplate.failure(PXPAY, err));
                });
        };
    }
}
